import { Dropdown } from 'braid-design-system';
import React from 'react';

import { Country, PopularCountries } from 'src/data/countries';
import { mapBraidFieldProps } from 'src/utils/mapBraidFieldProps';

import { useField } from '../formState';

const CountryField = () => {
  const phonePrefix = useField({
    id: 'phoneCountryCode',
  });

  return (
    <Dropdown
      id="phone-country-code-field"
      label="Country"
      {...mapBraidFieldProps(phonePrefix)}
    >
      <optgroup label="Common Countries">
        {PopularCountries.map(({ Id, Value, Name }) => (
          <option key={`${Id}`} value={`${Value}`}>
            {Name}
          </option>
        ))}
      </optgroup>
      <optgroup label="All Countries">
        {Country.map(({ Id, Value, Name }) => (
          <option key={`${Id}`} value={`${Value}`}>
            {Name}
          </option>
        ))}
      </optgroup>
    </Dropdown>
  );
};

export default CountryField;
